import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = [
    "sectionsContainer", "sectionTemplate",
    "ctasContainer",     "ctaTemplate",
    "faqsContainer",     "faqTemplate",
  ]

  declare sectionsContainerTarget: HTMLElement
  declare sectionTemplateTarget:   HTMLTemplateElement
  declare ctasContainerTarget:     HTMLElement
  declare ctaTemplateTarget:       HTMLTemplateElement
  declare faqsContainerTarget:     HTMLElement
  declare faqTemplateTarget:       HTMLTemplateElement

  addSection(event: Event): void {
    event.preventDefault()
    const index = Date.now().toString()
    const html = this.sectionTemplateTarget.innerHTML.replace(/SIDX/g, index)
    this.sectionsContainerTarget.insertAdjacentHTML("beforeend", html)
    this.sectionsContainerTarget.lastElementChild
      ?.querySelector<HTMLInputElement>("input[type=text]")
      ?.focus()
  }

  removeSection(event: Event): void {
    event.preventDefault()
    const block = (event.target as Element).closest<HTMLElement>("[data-section-block]")!
    const idInput = block.querySelector<HTMLInputElement>("input[name*='[id]']")
    if (idInput?.value) {
      const destroyInput = block.querySelector<HTMLInputElement>("input[name*='_destroy']")
      if (destroyInput) destroyInput.value = "1"
      block.classList.add("hidden")
    } else {
      block.remove()
    }
  }

  addCta(event: Event): void {
    event.preventDefault()
    const index = Date.now().toString()
    const html = this.ctaTemplateTarget.innerHTML.replace(/CIDX/g, index)
    this.ctasContainerTarget.insertAdjacentHTML("beforeend", html)
    this.ctasContainerTarget.lastElementChild
      ?.querySelector<HTMLInputElement>("input[type=text]")
      ?.focus()
  }

  removeCta(event: Event): void {
    event.preventDefault()
    const block = (event.target as Element).closest<HTMLElement>("[data-cta-block]")!
    const idInput = block.querySelector<HTMLInputElement>("input[name*='[id]']")
    if (idInput?.value) {
      const destroyInput = block.querySelector<HTMLInputElement>("input[name*='_destroy']")
      if (destroyInput) destroyInput.value = "1"
      block.classList.add("hidden")
    } else {
      block.remove()
    }
  }

  addFaq(event: Event): void {
    event.preventDefault()
    const index = Date.now().toString()
    const html = this.faqTemplateTarget.innerHTML.replace(/FIDX/g, index)
    this.faqsContainerTarget.insertAdjacentHTML("beforeend", html)
    this.faqsContainerTarget.lastElementChild
      ?.querySelector<HTMLInputElement>("input[type=text]")
      ?.focus()
  }

  removeFaq(event: Event): void {
    event.preventDefault()
    const block = (event.target as Element).closest<HTMLElement>("[data-faq-block]")!
    const idInput = block.querySelector<HTMLInputElement>("input[name*='[id]']")
    if (idInput?.value) {
      const destroyInput = block.querySelector<HTMLInputElement>("input[name*='_destroy']")
      if (destroyInput) destroyInput.value = "1"
      block.classList.add("hidden")
    } else {
      block.remove()
    }
  }
}
